import { render, staticRenderFns } from "./CollectionOverview.vue?vue&type=template&id=05797efa"
import script from "./CollectionOverview.vue?vue&type=script&lang=js"
export * from "./CollectionOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports